import React from "react";
import { H4 } from "@irati/ui/src/Headings";
import Flex from "@irati/ui/src/Flex";
import { Para, Label2, Strong } from "@irati/ui/src/Labels";
import { PastRangePicker as DateRangePicker } from "@irati/ui/src/temp/DateRangePicker";
import { LineChart, Line, XAxis, YAxis, Tooltip } from "recharts";
import { injectIntl } from "@irati/utils/lang";
import { perkbox } from "@irati/ui/src/global/colors";
import ConditionalWrapper from "../../ConditionalWrapper";
import { CustomResponsiveContainer, TooltipWrapper } from "../styled";
var colors = [perkbox.blue, perkbox.darkBlue, perkbox.greenBlue];
var renderCustomTooltip = function (_a) {
    var keyX = _a.keyX, labelX = _a.labelX, keyY = _a.keyY, labelY = _a.labelY, customTooltip = _a.customTooltip;
    return function (params) {
        var active = params.active, payload = params.payload;
        if (!active || !payload || !payload.length) {
            return null;
        }
        var item = payload[0].payload;
        return (React.createElement(TooltipWrapper, null,
            React.createElement(Flex, { justifyContent: "space-between", key: item[keyX] },
                React.createElement(Label2, null, labelX),
                React.createElement(Label2, null, item[keyX])),
            React.createElement(Flex, { justifyContent: "space-between" },
                React.createElement(Label2, null, labelY),
                React.createElement(Label2, null, item[keyY])),
            customTooltip &&
                customTooltip.map(function (_a) {
                    var label = _a.label, key = _a.key;
                    return (React.createElement(Flex, { justifyContent: "space-between", key: label },
                        React.createElement(Label2, null, label),
                        React.createElement(Label2, null, item[key])));
                })));
    };
};
var Chart = function (_a) {
    var icon = _a.icon, title = _a.title, _b = _a.subtitle, subtitle = _b === void 0 ? "" : _b, _c = _a.description, description = _c === void 0 ? "" : _c, data = _a.data, _d = _a.chartHeight, chartHeight = _d === void 0 ? 300 : _d, _e = _a.chartWidth, chartWidth = _e === void 0 ? 500 : _e, _f = _a.hideTooltip, hideTooltip = _f === void 0 ? false : _f, tooltipFn = _a.tooltipFn, _g = _a.dot, dot = _g === void 0 ? false : _g, xInterval = _a.xInterval, _h = _a.hideAxis, hideAxis = _h === void 0 ? false : _h, _j = _a.nonResponsiveChart, nonResponsiveChart = _j === void 0 ? false : _j, onDateSelect = _a.onDateSelect, startDate = _a.startDate, endDate = _a.endDate, preset = _a.preset;
    var _k = data || {}, keyX = _k.keyX, _l = _k.keyY, keyY = _l === void 0 ? "date" : _l, _m = _k.values, values = _m === void 0 ? [] : _m;
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { justifyContent: "space-between" },
            icon && "icon",
            title && React.createElement(H4, null,
                React.createElement(Strong, null, title),
                " ",
                subtitle),
            onDateSelect && (React.createElement(DateRangePicker, { startDate: startDate, endDate: endDate, preset: preset, onSave: onDateSelect, defaultToPreset: true, rightAlign: true }))),
        description && React.createElement(Para, null, description),
        values.length > 0 && (React.createElement(ConditionalWrapper, { condition: !nonResponsiveChart, wrapper: function (children) { return React.createElement(CustomResponsiveContainer, { height: chartHeight + 100 }, children); } },
            React.createElement(LineChart, { width: chartWidth, height: chartHeight },
                !hideAxis && React.createElement(XAxis, { dataKey: keyX, type: "category", allowDuplicatedCategory: false, interval: xInterval }),
                !hideAxis && React.createElement(YAxis, { dataKey: keyY }),
                !hideTooltip && React.createElement(Tooltip, { content: tooltipFn || data && renderCustomTooltip(data) }),
                values.map(function (series, idx) {
                    var points = series.points, info = series.info;
                    var strokeColor = (info === null || info === void 0 ? void 0 : info.color) || colors[idx % colors.length];
                    return points && points.length > 0 &&
                        React.createElement(Line, { key: idx, type: "monotone", data: points, dataKey: keyY, stroke: strokeColor, dot: dot });
                }))))));
};
export default injectIntl(Chart);
